module.exports = __webpack_public_path__ + "img/newcrash.ead234b3.svg";